var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" Receipt Payment "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.ReceiptPaymentDetail.name,
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [_c("span", [_vm._v(" Invoices ")])]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }